import { c as _c } from "react/compiler-runtime";
import { FormInput } from '@systemeio/ui';
import { addPaypal } from 'modules/profile/affiliate-program-settings/api/affiliate-program-settings-api';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
export interface AffiliateProgramPaypalInterface {
  clientId: string;
  secret: string;
}
const defaultValues: AffiliateProgramPaypalInterface = {
  clientId: '',
  secret: ''
};
const defaultErrors: AffiliateProgramPaypalInterface = {
  clientId: '',
  secret: ''
};
interface AffiliateProgramPaypalProps {
  onPaypalAdd: (clientId: string) => Promise<void>;
}
const AffiliateProgramPaypal = t0 => {
  const $ = _c(30);
  const {
    onPaypalAdd
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] !== onPaypalAdd) {
    t1 = async data => {
      await fetchWithErrors(async () => {
        await addPaypal(data);
        await onPaypalAdd(data.clientId);
      }, setErrors);
    };
    $[0] = onPaypalAdd;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCreate = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.settings.affiliate_program.connect_paypal");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <button className="primary-link" onClick={t2}>{t3}</button>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["secret", "clientId"];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("dashboard.settings.affiliate_program.add_paypal_credentials");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onCreate) {
    t7 = data_0 => onCreate(data_0);
    $[10] = onCreate;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(false);
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== errors || $[14] !== t) {
    t9 = {
      field: "clientId",
      onRender: (value, onChange) => <FormInput key="clientId" value={value} onChange={e_0 => onChange(e_0.target.value)} label={t("dashboard.settings.affiliate_program.paypal_client_id")} error={errors.clientId} />
    };
    $[13] = errors;
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== errors || $[17] !== t) {
    t10 = {
      field: "secret",
      onRender: (value_0, onChange_0) => <FormInput key="secret" value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} label={t("dashboard.settings.affiliate_program.paypal_client_secret")} error={errors.secret} />
    };
    $[16] = errors;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = [t9, t10];
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== opened || $[23] !== t11 || $[24] !== t6 || $[25] !== t7) {
    t12 = <CreateModal requiredFields={t5} fullCaption={t6} opened={opened} needToast={false} onCreate={t7} onClose={t8} defaultValues={defaultValues} creatable={t11} />;
    $[22] = opened;
    $[23] = t11;
    $[24] = t6;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t4) {
    t13 = <>{t4}{t12}</>;
    $[27] = t12;
    $[28] = t4;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export default AffiliateProgramPaypal;